import { render, staticRenderFns } from "./OzAlertDialogBox.vue?vue&type=template&id=114e8923&"
import script from "./OzAlertDialogBox.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OzAlertDialogBox.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports